export default __webpack_public_path__ + "static/media/folder.a5cc8857.svg";